import { TwitterPublicSuggestionResponse } from '~/utils/channels/twitter/types';
import { AutocompleteItem } from '../../autocomplete';

const topic = {
  topic: '#TestTopic',
};

export const emptyApiResponse = {
  users: [],
  num_results: 0,
  topics: [],
  events: [],
  lists: [],
  ordered_sections: [],
  oneclick: [],
  hashtags: [],
  completed_in: 0.1,
  query: 'null',
} as TwitterPublicSuggestionResponse;

export const validApiResponse = {
  ...emptyApiResponse,
  num_results: 2,
  topics: [topic],
} as TwitterPublicSuggestionResponse;

export const validHashtagItem: AutocompleteItem = {
  key: '#TestTopic',
  text: 'TestTopic',
  data: {
    handle: '#TestTopic',
  },
};
